import { useState, useEffect } from "react";
import * as Constants from "../constants";

const useComments = (token) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchComments = async () => {
    setLoading(true);
    setError(null);

    try {
      const resp = await fetch(`${Constants.apiUrl}/setup/custom-comment`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      console.log(data, "comments");

      if (data) {
        setComments(data.customs || []);
      } else {
        setError(data.status || "Failed to fetch comments");
      }
    } catch (err) {
      setError("Error fetching comments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchComments();
    }
  }, [token]);

  return {
    comments,
    loading,
    error,
  };
};

export default useComments;
